import React from "react";
import { useNavigate } from "react-router-dom";
const NavBar = () => {
    const navigate = useNavigate()
  return (
    <>
      <nav class="navbar navbar-expand-lg navbar-light bg-white py-3">
        <div class="container px-5">
          <a class="navbar-brand" href="index.html">
            <span class="fw-bolder text-primary">G-DEV</span>
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0 small fw-bolder">
              <li class="nav-item" style={{cursor:'pointer'}}>
                <a class="nav-link" onClick={(ev)=>{
                    ev.preventDefault()
                    navigate('/')
                }}>
                  Accueil
                </a>
              </li>
              <li class="nav-item" style={{cursor:'pointer'}}>
                <a class="nav-link" onClick={(ev)=>{
                    ev.preventDefault()
                    navigate('/Parcours')
                }}>
                  Parcours
                </a>
              </li>
              <li class="nav-item" style={{cursor:'pointer'}}>
                <a class="nav-link" onClick={(ev)=>{
                    ev.preventDefault()
                    navigate('/Projet')
                }}>
                  Projets
                </a>
              </li>
              <li class="nav-item" style={{cursor:'pointer'}}>
                <a class="nav-link" onClick={(ev)=>{
                    ev.preventDefault()
                    navigate('/Contacte')
                }}>
                  Contacte
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
